<div class="modal-header">
  <div class="d-flex align-items-center gap-3 flex-fill">
    <div class="d-flex align-items-center gap-2">
      <div class="modal-title" i18n>Combine Rentals to Multi-Unit</div>
      <app-page-help articleId="cWz1SL2PRXdzh49of4tSkS" videoId=""></app-page-help>
    </div>
    <div class="flex-fill"></div>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<mat-stepper [linear]="true" #stepper class="m-3">
  <mat-step i18n-label label="Multi-Unit Details" [state]="stepper.selectedIndex > 0 ? 'done' : 'number'">
    <div class="container-box">
      <div class="d-flex align-items-start gap-3 p-3" style="background: #fcfcfd">
        <img src="/assets/images/rental-group/multi-unit-1.svg" alt="" width="100" />
        <div class="flex-1">
          <h6 i18n class="mb-1">Manage multiple units under one main listing with ease.</h6>
          <div i18n class="text-sm text-muted">
            Multi-Units allow you to manage several subunits within a single rental. Each subunit can have its own
            pricing, availability, and details.
          </div>
          <div class="alert alert-secondary-warning2 text-warning2 mb-0 mt-1 p-2">
            <div i18n class="text-semi-bold">For example:</div>
            <div i18n>an apartment building with 5 identical rooms can be listed as a Multi-Unit rental.</div>
          </div>
        </div>
      </div>
      <div class="p-3 border-top border-bottom">
        <ng-template [ngTemplateOutlet]="multiCreate"></ng-template>
        <div class="mt-3">
          <ng-template [ngTemplateOutlet]="multiConnect"></ng-template>
        </div>
      </div>
      <div class="p-3" style="background: #fcfcfd">
        <div i18n>Preview:</div>
        <ul class="list-unstyled d-flex flex-column mb-0 overflow-auto" style="row-gap: 1px; max-height: 200px">
          <li
            *ngIf="form.get('name').value as name"
            class="d-flex align-items-center gap-2 position-relative bg-active text-truncate"
            #parentRow
            style="min-height: 30px; padding: 0 25px 0"
          >
            <app-rental-group-label
              label="Multi"
              labelClass="bg-indigo text-white"
              [height]="parentRow.offsetHeight"
              class="position-absolute fw-normal"
              [style.left.px]="-7"
            ></app-rental-group-label>
            <div class="text-truncate">
              {{ name }}
              <span i18n class="text-light text-sm">(Main Unit)</span>
            </div>
          </li>
          <ng-container *ngFor="let item of unitForm.get('items').value">
            <li
              class="d-flex align-items-center gap-2 position-relative bg-default text-truncate"
              #child1Row
              *ngIf="item.name"
              style="min-height: 30px; padding: 0 25px 0"
            >
              <app-rental-group-label
                label="Sub"
                labelClass="text-indigo bg-secondary-indigo"
                [height]="child1Row.offsetHeight"
                class="position-absolute fw-normal"
                [style.left.px]="-7"
              ></app-rental-group-label>
              <div class="text-truncate">{{ item.name }}</div>
            </li>
          </ng-container>
          <li
            *ngFor="let id of unitForm.get('connected').value"
            class="d-flex align-items-center gap-2 position-relative bg-default text-truncate"
            #child2Row
            style="min-height: 30px; padding: 0 25px 0"
          >
            <app-rental-group-label
              label="Sub"
              labelClass="text-indigo bg-secondary-indigo"
              [height]="child2Row.offsetHeight"
              class="position-absolute fw-normal"
              [style.left.px]="-7"
            ></app-rental-group-label>
            <div class="text-truncate">{{ id | rentalName | async }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="mt-3 d-flex align-items-center gap-3">
      <div class="flex-fill"></div>
      <button (click)="close()" type="button" class="btn btn-light">
        <i class="far fa-times"></i> <ng-container i18n>Cancel </ng-container>
      </button>
      <button class="btn btn-secondary-info" (click)="onNext(form, stepper)">
        <ng-container i18n>Next</ng-container>
        <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
      </button>
    </div>
  </mat-step>
  <mat-step i18n-label label="Rental Details" [state]="stepper.selectedIndex > 1 ? 'done' : 'number'">
    <div class="container-box p-3">
      <div class="">
        <ng-template [ngTemplateOutlet]="rentalInfo"></ng-template>
      </div>
      <div class="mt-4">
        <ng-template [ngTemplateOutlet]="rentalLocation"></ng-template>
      </div>
    </div>
    <div class="mt-3 d-flex align-items-center gap-3">
      <div class="flex-fill"></div>
      <button class="btn btn-outline-light" (click)="onPrevious(stepper)">
        <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
        <ng-container i18n>Previous</ng-container>
      </button>
      <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSave(form)">
        <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
        <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </mat-step>
  <ng-template matStepperIcon="done">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
  <ng-template matStepperIcon="edit">
    <i class="cs-icon cs-icon-check2 text-xs"></i>
  </ng-template>
</mat-stepper>

<ng-template let-ctrl="ctrl" let-label="label" let-onChange="onChange" #rentalNameField>
  <mat-form-field2 class="mat-block">
    <input
      type="text"
      [formControl]="ctrl"
      matInput
      required
      [placeholder]="label"
      (input)="onChange?.($event.target.value)"
      autocomplete="off"
    />
    <mat-error *ngIf="ctrl?.touched && ctrl?.hasError('required')" i18n> Name is required </mat-error>
    <mat-error *ngIf="ctrl?.hasError('allNumbers')" i18n> Name cannot be numbers alone. </mat-error>
    <mat-error *ngIf="ctrl?.hasError('allSpaces')" i18n> Name cannot be spaces alone. </mat-error>
    <mat-error *ngIf="ctrl?.hasError('minlength')"> Name must be at least 2 characters long </mat-error>
    <mat-error *ngIf="ctrl?.hasError('maxlength')" i18n> Name must be at most 140 characters long </mat-error>
    <mat-error *ngIf="ctrl?.hasError('nameTaken')" i18n> Name is already in use by another rental. </mat-error>
  </mat-form-field2>
</ng-template>

<ng-template #multiCreate>
  <ng-template
    [ngTemplateOutlet]="rentalNameField"
    [ngTemplateOutletContext]="{ ctrl: form.get('name'), label: 'Main Unit Name', onChange: onNameChange }"
  >
  </ng-template>
  <ng-container *ngFor="let item of newUnitsArray.controls; let i = index; let count">
    <div class="d-flex gap-3" [formGroup]="item">
      <ng-template
        [ngTemplateOutlet]="rentalNameField"
        [ngTemplateOutletContext]="{ ctrl: item.get('name'), label: 'Subunit Name' }"
      >
      </ng-template>
      <mat-form-field2>
        <input
          type="number"
          formControlName="multi_unit_priority"
          matInput
          required
          i18n-placeholder
          placeholder="Priority"
          matTooltip="Defines the booking order for subunits. Higher numbers get booked first."
          i18n-matTooltip
        />
        <mat-error
          *ngIf="item.get('multi_unit_priority').touched && item.get('multi_unit_priority').hasError('required')"
          i18n
        >
          Priority is required
        </mat-error>
        <mat-error *ngIf="item.get('multi_unit_priority').hasError('integer')" i18n>
          value should be integer
        </mat-error>
        <mat-error *ngIf="item.get('multi_unit_priority').hasError('min')" i18n> Min value is 1 </mat-error>
        <mat-error *ngIf="item.get('multi_unit_priority').hasError('max')" i18n> Max value is 100 </mat-error>
        <mat-error *ngIf="item.get('multi_unit_priority').hasError('existing')" i18n>
          Priority already exists
        </mat-error>
      </mat-form-field2>
      <app-form-switch
        formControlName="multi_unit_status"
        [checkedValue]="1"
        [uncheckedValue]="0"
        [inline]="true"
        i18n-matTooltip
        matTooltip="When enabled, the subunit is active and available for bookings. When disabled, it cannot be booked but will still appear on the calendar as inactive. You can change this anytime"
        i18n
        style="margin-top: 2.25rem"
        >Status</app-form-switch
      >
      <button class="btn btn-secondary-danger align-input-row-end" type="button" (click)="onRemoveUnit(i)">
        <i class="cs-icon cs-icon-trash"></i>
      </button>
    </div>
  </ng-container>
  <a (click)="onNewUnit()"><i class="far fa-plus"></i>&nbsp; <ng-container i18n>Add New Subunit</ng-container></a>
</ng-template>

<ng-template #multiConnect>
  <ng-container [formGroup]="unitForm">
    <app-rental-select
      [ctrl]="unitForm.get('connected')"
      [rentals$]="rentals$"
      [isSelectable]="isSubunitSelectable"
      [getTooltip]="getTooltip"
      i18n-label
      label="Add Existing Rental as Subunit"
    ></app-rental-select>
  </ng-container>
</ng-template>

<ng-template #rentalInfo>
  <ng-container [formGroup]="form">
    <h6 class="text-light fw-medium text-uppercase mb-2" i18n>Rental Information</h6>
    <div class="card p-3">
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="phone" matInput i18n-placeholder placeholder="Phone" />
            <mat-error *ngIf="form.get('phone').touched && form.get('phone').hasError('required')" i18n>
              Phone is required
            </mat-error>
            <mat-error *ngIf="form.get('phone').hasError('allSpaces')" i18n> Phone cannot be spaces alone. </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="email"
              formControlName="registration"
              matInput
              i18n-placeholder
              placeholder="Registration Number"
              autocomplete="off"
            />
          </mat-form-field2>
        </div>
      </div>
      <mat-form-field2 class="mat-block">
        <input
          type="text"
          formControlName="email"
          matInput
          required
          i18n-placeholder
          placeholder="AdvanceCM Email"
          autocomplete="off"
        />
        <span *ngIf="form.get('name').value.length > 0 || form.get('email').value.length > 0" matSuffix
          >@{{ subDomain }}</span
        >
        <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')" i18n>
          Email is required
        </mat-error>
        <mat-error *ngIf="form.get('email').hasError('minlength')" i18n>
          Email handle must be at least 3 characters long
        </mat-error>
        <mat-error *ngIf="form.get('email').hasError('emailTaken')" i18n>
          Email is already in use by another rental.
        </mat-error>
        <mat-error *ngIf="form.get('email').hasError('rentalEmail')" i18n> Email is invalid. </mat-error>
      </mat-form-field2>

      <div>
        <label class="form-field-label" i18n>Calendar Colors</label>
        <app-color-boxes [ctrl]="form.get('color')"></app-color-boxes>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #rentalLocation>
  <ng-container [formGroup]="addressForm">
    <h6 class="text-light fw-medium text-uppercase mb-2" i18n>Rental Location</h6>
    <div class="card p-3">
      <div>
        <mat-form-field2 class="mat-block">
          <input
            appGooglePlaces
            (onAddressChange)="onPlaceChange($event)"
            autocomplete="address-1"
            type="text"
            formControlName="address"
            matInput
            i18n-placeholder
            placeholder="Address"
          />
          <mat-error *ngIf="addressForm.get('address').hasError('minlength')" i18n>
            Address must be at least 2 characters long
          </mat-error>
          <mat-error *ngIf="addressForm.get('address').hasError('maxlength')" i18n>
            Address must be at most 140 characters long
          </mat-error>
          <mat-error *ngIf="addressForm.get('address').hasError('allSpaces')" i18n>
            Address cannot be spaces alone.
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              appGooglePlaces
              (onAddressChange)="onCityChange($event)"
              type="text"
              formControlName="city"
              matInput
              i18n-placeholder
              placeholder="City"
            />
            <mat-error *ngIf="addressForm.get('city').touched && addressForm.get('city').hasError('required')" i18n>
              City is required
            </mat-error>
            <mat-error *ngIf="addressForm.get('city').hasError('minlength')" i18n>
              City must be at least 2 characters long
            </mat-error>
            <mat-error *ngIf="addressForm.get('city').hasError('maxlength')" i18n>
              City must be at most 50 characters long
            </mat-error>
            <mat-error *ngIf="addressForm.get('city').hasError('allSpaces')" i18n>
              City cannot be spaces alone.
            </mat-error>
          </mat-form-field2>
          <app-country-select
            [nameCtrl]="addressForm.get('country')"
            [codeCtrl]="addressForm.get('country_code')"
            [showBlankItem]="false"
          ></app-country-select>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="state"
              matInput
              i18n-placeholder
              placeholder="State / Province / Region"
            />
            <mat-error *ngIf="addressForm.get('state').hasError('minlength')" i18n>
              Value must be at least 2 characters long
            </mat-error>
            <mat-error *ngIf="addressForm.get('state').hasError('maxlength')" i18n>
              Value must be at most 50 characters long
            </mat-error>
            <mat-error *ngIf="addressForm.get('state').hasError('allSpaces')" i18n>
              State cannot be spaces alone.
            </mat-error>
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <input type="text" formControlName="zip" matInput placeholder="Postal Code" />
            <mat-error *ngIf="addressForm.get('zip').hasError('minlength')" i18n>
              Value must be at least 2 characters long
            </mat-error>
            <mat-error *ngIf="addressForm.get('zip').hasError('maxlength')" i18n>
              Value must be at most 50 characters long
            </mat-error>
            <mat-error *ngIf="addressForm.get('zip').hasError('allSpaces')" i18n>
              Postal code cannot be spaces alone.
            </mat-error>
          </mat-form-field2>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
